import { CheckCircleIcon, EmptyState } from '@buffer-mono/popcorn'

import styles from './RepliedToManyComments.module.css'

export const RepliedToManyComments = (): JSX.Element => {
  return (
    <EmptyState
      size="large"
      variant="success"
      role="status"
      aria-label="All comments have been addressed"
      className={styles.wrapper}
    >
      <EmptyState.Icon>
        <CheckCircleIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>
        You&apos;ve replied to 20+ comments!
      </EmptyState.Heading>
      <EmptyState.Description>
        You&apos;re all caught up! We will let you know when new comments
        appear.
      </EmptyState.Description>
    </EmptyState>
  )
}
